import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import moment from 'moment-timezone';
import * as analytics from 'shared/lib/analytics';
import PaymentLayout from 'shared/lib/components/PaymentLayout';
import LineItemsList from 'shared/lib/components/LineItemsList';
import SectionWrapper from 'shared/lib/components/SectionWrapper';

const propTypes = {
  extensionPolicy: PropTypes.object,
  extensionReturnDate: PropTypes.object,
  getRentalCarExtensionCheckout: PropTypes.func,
  isPurchaseInProgress: PropTypes.bool,
  policy: PropTypes.object,
  totals: PropTypes.object,
  purchaseRentalCarExtension: PropTypes.func,
};

const defaultProps = {
  extensionPolicy: {},
  extensionReturnDate: {},
  getRentalCarExtensionCheckout: () => {},
  isPurchaseInProgress: false,
  policy: {},
  totals: {},
  purchaseRentalCarExtension: () => {},
};

class RentalCarExtensionPayment extends Component {
  componentDidMount() {
    analytics.page('Rental Car - Checkout - Extension');
    analytics.track('Checkout Step Viewed', {
      category: 'order',
      step: 2,
    });
    this.props.getRentalCarExtensionCheckout();
  }

  handleSubmit = ({ cardElement }) => {
    this.props.purchaseRentalCarExtension(cardElement).then(purchaseData => {
      this.props.navTo(
        `/rental-car-insurance/extension/${
          this.props.params.policyId
        }/confirmation`
      );
    });
  };

  render() {
    const {
      extensionPolicy,
      totals,
      isRentalCarInProgress,
      extensionReturnDate,
      policy,
    } = this.props;

    return (
      <div className="RentalCarExtensionPayment Container Container--small">
        <PaymentLayout
          title="Your Rental Car Protection Extension"
          policyDocUrl={extensionPolicy.sample_policy}
          icon="directions_car"
          isPurchaseInProgress={isRentalCarInProgress}
          totals={totals}
          onSubmit={this.handleSubmit}
        >
          <SectionWrapper title="Rental car details">
            <LineItemsList
              rows={[
                [
                  'Original return date',
                  moment(
                    get(policy, 'details.rental_ended'),
                    'YYYY-MM-DD'
                  ).format('MMM D, YYYY'),
                ],
                [
                  'New return date',
                  extensionReturnDate &&
                    extensionReturnDate.tz('UTC').format('MMM D, YYYY'),
                ],
              ]}
            />
          </SectionWrapper>

          <SectionWrapper title="Coverage details">
            <LineItemsList
              rows={[
                ['Underwritten by', 'Chubb'],
                [
                  'Start date',
                  moment(
                    get(policy, 'details.rental_started'),
                    'YYYY-MM-DD'
                  ).format('MMM D, YYYY'),
                ],
                [
                  'End date',
                  extensionReturnDate &&
                    extensionReturnDate.tz('UTC').format('MMM D, YYYY'),
                ],
              ]}
            />
          </SectionWrapper>
        </PaymentLayout>
      </div>
    );
  }
}

RentalCarExtensionPayment.propTypes = propTypes;
RentalCarExtensionPayment.defaultProps = defaultProps;

export default RentalCarExtensionPayment;
